class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
  }

  checkButtonVisibility() {
    const atcButton = document.querySelector('.product-form__buttons .product-form__submit[name="add"]');
    if (!atcButton) {
      console.error('ATC not found');
      return
    }

    const rect = atcButton.getBoundingClientRect();
    const isVisible = (
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );

    if (isVisible) {
      this.classList.add('visually-hidden');
    } else {
      this.classList.remove('visually-hidden');
    }
  }

  initButtonActions() {
    const newAtcButton = this.querySelector('.sticky-atc__button--to-cart');
    const newBuyNowButton = this.querySelector('.sticky-atc__button--buy-now');
    const selectedVariant = this.getAttribute('data-selected-variant');
    const diffuserLayout = this.getAttribute('data-diffuser-layout');

    this.updateInputs(selectedVariant, diffuserLayout);

    const setupButtons = () => {
      const atcButton = document.querySelector('.product-form__buttons .product-form__submit[name="add"]');
      const buyNowButton = document.querySelector('.product-form__buttons .shopify-payment-button__button');
      const stickyQuantityInputs = document.querySelectorAll('.sticky_quantity__input');

      if (atcButton && newAtcButton) {
        if (selectedVariant == "" && diffuserLayout == "true") {
          newAtcButton.classList.add('sticky-atc__button--disabled');
        } else {
          newAtcButton.addEventListener('click', () => {
            atcButton.click();
            // ✅ REMOVED: Don't reset quantity to 1
          });
        }
      }

      if (buyNowButton && newBuyNowButton) {
        if (selectedVariant == "" && diffuserLayout == "true") {
          newBuyNowButton.classList.add('sticky-atc__button--disabled');
        } else {
          newBuyNowButton.addEventListener('click', () => buyNowButton.click());
        }
      }

      if ((atcButton && newAtcButton) && (buyNowButton && newBuyNowButton)) {
        clearInterval(checkInterval);
      }
    };

    const checkInterval = setInterval(setupButtons, 1000);
  }

  updateInputs(selectedVariant, diffuserLayout) {
    if (selectedVariant !== '' && diffuserLayout === 'true') {
      const inputs = document.querySelectorAll('.product-form__input--pill input');
      const checkedInput = Array.from(inputs).find(input => input.checked);

      if (checkedInput) {
        checkedInput.classList.add('input-pill--checked');
      }
    }

    const elementsToBlock = document.querySelectorAll('.product-form__input, variant-selects, legend');
    const eventsToBlock = ['click', 'change', 'input'];

    elementsToBlock.forEach((element) => {
      eventsToBlock.forEach((eventName) => {
        element.addEventListener(eventName, (event) => {
          if (event.currentTarget === event.target) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
      });
    });
  }

  setFooterMargin() {
    const footerContentBottom = document.querySelector('.footer__content-bottom-wrapper--center');

    if (footerContentBottom && this) {
      const stickyHeight = this.offsetHeight;
      footerContentBottom.style.marginBottom = `${stickyHeight}px`;
    }
  }

  initQuantitySelector() {
    const quantityInputs = document.querySelectorAll('.quantity__input');
    const stickyQuantityInputs = document.querySelectorAll('.sticky_quantity__input');
    const minusButtons = document.querySelectorAll('.quantity-btn.minus');
    const plusButtons = document.querySelectorAll('.quantity-btn.plus');
    const priceElement = document.querySelector('#UpdatedPrice');
    const priceElementMobile = document.querySelector('#UpdatedPriceMobile');

    if (!priceElement || !priceElementMobile || !quantityInputs.length || !stickyQuantityInputs.length || !minusButtons.length || !plusButtons.length) {
      console.error('Missing elements for quantity selector.');
      return;
    }

    const originalPrice = parseFloat(priceElement.textContent.replace('$', '').trim());

    const updateQuantityAndPrice = (newQuantity) => {
      const newPrice = (originalPrice * newQuantity).toFixed(2);
      priceElement.textContent = `$${newPrice}`;
      priceElementMobile.textContent = `$${newPrice}`;
      quantityInputs.forEach(input => input.value = newQuantity);
      stickyQuantityInputs.forEach(input => input.value = newQuantity);
    };

    minusButtons.forEach(button => {
      button.addEventListener('click', () => {
        const currentQuantity = parseInt(stickyQuantityInputs[0].value);
        if (currentQuantity > 1) {
          const newQuantity = currentQuantity - 1;
          updateQuantityAndPrice(newQuantity);
        }
      });
    });

    plusButtons.forEach(button => {
      button.addEventListener('click', () => {
        const currentQuantity = parseInt(stickyQuantityInputs[0].value);
        const newQuantity = currentQuantity + 1;
        updateQuantityAndPrice(newQuantity);
      });
    });

    stickyQuantityInputs.forEach(input => {
      input.addEventListener('input', () => {
        let newQuantity = parseInt(input.value);
        if (isNaN(newQuantity) || newQuantity < 1) newQuantity = 1;
        updateQuantityAndPrice(newQuantity);
      });
    });

    quantityInputs.forEach(input => {
      input.addEventListener('input', () => {
        let newQuantity = parseInt(input.value);
        if (isNaN(newQuantity) || newQuantity < 1) newQuantity = 1;
        updateQuantityAndPrice(newQuantity);
      });
    });

    const initialQuantity = parseInt(stickyQuantityInputs[0].value) || 1;
    updateQuantityAndPrice(initialQuantity);

    this.updateQuantityAndPrice = updateQuantityAndPrice.bind(this);
  }

  listenForQuantityUpdates() {
    document.addEventListener('quantity:updated', (event) => {
      const newQuantity = event.detail.newQuantity;
      this.updateQuantityAndPrice(newQuantity);
    });
  }

  // ✅ UPDATED: Listen for subscription changes
  listenForSubscriptionChanges() {
    document.addEventListener('subscription:changed', (event) => {
      const { quantity, isSubscription } = event.detail;
      
      // Update all quantity inputs
      const allQtyInputs = document.querySelectorAll('.quantity__input, .sticky_quantity__input');
      allQtyInputs.forEach(input => {
        if (input) input.value = quantity;
      });
      
      // Update price if function exists
      if (this.updateQuantityAndPrice) {
        this.updateQuantityAndPrice(quantity);
      }
      
      // ✅ NEW: Update sticky button text with price
      this.updateStickyButtonPrice();
      
      // Disable/Enable buttons based on subscription status
      this.toggleQuantityButtons(isSubscription);
    });
  }

  // ✅ NEW METHOD: Update sticky button with price
  updateStickyButtonPrice() {
    const widget = document.querySelector('.sub-widget');
    if (!widget) return; // Only run if subscription widget exists
    
    const stickyButton = this.querySelector('.sticky-atc__button--to-cart');
    if (!stickyButton) return;
    
    // Find the checked radio's price
    const checkedRadio = widget.querySelector('.sub-widget__radio:checked');
    if (!checkedRadio) return;
    
    const priceContainer = checkedRadio.closest('li, .sub-widget__item');
    const priceElement = priceContainer?.querySelector('.sub-widget__price');
    
    if (priceElement) {
      // Extract price like "$148.00" from the text
      const priceText = priceElement.textContent.trim();
      const priceMatch = priceText.match(/\$[\d,]+\.?\d*/);
      
      if (priceMatch) {
        stickyButton.textContent = `ADD TO CART ${priceMatch[0]}`;
        return;
      }
    }
    
    // Fallback: keep original text
    stickyButton.textContent = 'Add to cart';
  }

  toggleQuantityButtons(shouldDisable) {
    const minusButtons = document.querySelectorAll('.quantity-btn.minus, .quantity__button[name="minus"]');
    const plusButtons = document.querySelectorAll('.quantity-btn.plus, .quantity__button[name="plus"]');
    const qtyInputs = document.querySelectorAll('.quantity__input, .sticky_quantity__input');
    
    minusButtons.forEach(btn => {
      if (btn) {
        btn.disabled = shouldDisable;
        btn.style.opacity = shouldDisable ? '0.5' : '1';
        btn.style.cursor = shouldDisable ? 'not-allowed' : 'pointer';
      }
    });
    
    plusButtons.forEach(btn => {
      if (btn) {
        btn.disabled = shouldDisable;
        btn.style.opacity = shouldDisable ? '0.5' : '1';
        btn.style.cursor = shouldDisable ? 'not-allowed' : 'pointer';
      }
    });
    
    qtyInputs.forEach(input => {
      if (input) input.readOnly = shouldDisable;
    });
  }

  connectedCallback() {
    const alwaysVisible = this.getAttribute('data-always-visible');

    if (alwaysVisible) {
      this.setFooterMargin();
    } else {
      this.checkButtonVisibility();
      window.addEventListener('scroll', () => this.checkButtonVisibility());
    }

    this.initButtonActions();
    this.initQuantitySelector();
    this.listenForQuantityUpdates();
    this.listenForSubscriptionChanges();
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
